/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "button": {
    "extend": {
      "size_large": "my-4"
    }
  },
  "login_caption_colors_default": "",
  "login_caption_size_default": "text-body-md",
  "login_caption_variant_default": "",
  "login_footer_colors_default": "",
  "login_footer_size_default": "text-headline-sm",
  "login_footer_variant_default": "",
  "login_headline_colors_default": "",
  "login_headline_size_default": "text-headline-md",
  "login_headline_variant_default": "",
  "login_colors_default": "",
  "login_size_default": "gap-y-2",
  "login_variant_default": "flex flex-col items-center text-center",
  "purchase_colors_default": "",
  "purchase_size_default": "",
  "purchase_variant_default": "",
  "colors_default": "before:bg-gradient-to-t before:from-white",
  "size_default": "w-full py-9 before:w-full before:h-69",
  "variant_default": "relative before:absolute before:left-0 before:bottom-full"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "ContentLock");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;